module.exports = __webpack_public_path__ + "static/media/comcast_business.20c70825.png";